module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('h2', {
    staticStyle: {
      "padding": "0.3rem 0",
      "text-align": "center"
    }
  }, [_vm._v("2020-2021年全国啦啦操联赛")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "序号",
      "placeholder": "请输入身份证号",
      "readOnly": ""
    },
    model: {
      value: (_vm.row.current_index + 1),
      callback: function($$v) {
        _vm.$set(_vm.row, "current_index + 1", $$v)
      },
      expression: "row.current_index + 1"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "参赛项目",
      "placeholder": "请输入参赛项目",
      "readOnly": ""
    },
    model: {
      value: (_vm.row.subject.subject_name),
      callback: function($$v) {
        _vm.$set(_vm.row.subject, "subject_name", $$v)
      },
      expression: "row.subject.subject_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "参赛单位",
      "placeholder": "请输入姓名",
      "readOnly": ""
    },
    model: {
      value: (_vm.row.subject.danwei),
      callback: function($$v) {
        _vm.$set(_vm.row.subject, "danwei", $$v)
      },
      expression: "row.subject.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "参赛队伍",
      "placeholder": "请输入姓名",
      "readOnly": ""
    },
    model: {
      value: (_vm.row.subject.mingcheng),
      callback: function($$v) {
        _vm.$set(_vm.row.subject, "mingcheng", $$v)
      },
      expression: "row.subject.mingcheng"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "score-box"
  }, [_c('div', {
    staticClass: "score-title"
  }, [_vm._v("比赛用时")]), _vm._v(" "), _c('div', {
    staticClass: "score-content"
  }, [(_vm.type == 'auto') ? _c('div', {
    staticClass: "score-time"
  }, [(_vm.timeString) ? _c('h3', {
    staticClass: "time-value"
  }, [_vm._v(_vm._s(_vm.timeString))]) : _c('h3', {
    staticClass: "time-value"
  }, [_vm._v("00:00:00")]), _vm._v(" "), _c('div', {
    staticClass: "time-button flex-between"
  }, [(_vm.status == 'pause') ? _c('van-button', {
    attrs: {
      "type": "info",
      "size": "large",
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 ? true : false
    },
    on: {
      "click": _vm.onTimeContinue
    }
  }, [_vm._v("\n                        继续计时\n                    ")]) : _c('van-button', {
    attrs: {
      "type": "info",
      "size": "large",
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 ? true : false
    },
    on: {
      "click": _vm.onTimeStart
    }
  }, [_vm._v("开始计时\n                    ")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "info",
      "size": "large",
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 || !_vm.status ? true : false
    },
    on: {
      "click": _vm.onTimePause
    }
  }, [_vm._v("暂停\n                    ")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "info",
      "size": "large",
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 ? true : false
    },
    on: {
      "click": _vm.onTimeRestart
    }
  }, [_vm._v("重新计时\n                    ")])], 1)]) : _c('div', {
    staticClass: "score-time",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('div', {
    staticClass: "time-button flex-between"
  }, [_c('div', [_vm._v("请输入比赛用时：")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 ? true : false
    },
    model: {
      value: (_vm.time.minute),
      callback: function($$v) {
        _vm.$set(_vm.time, "minute", $$v)
      },
      expression: "time.minute"
    }
  }), _vm._v(" "), _c('div', [_vm._v("分")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "disabled": _vm.getTimeSecond(_vm.formData.time) > 0 ? true : false
    },
    model: {
      value: (_vm.time.second),
      callback: function($$v) {
        _vm.$set(_vm.time, "second", $$v)
      },
      expression: "time.second"
    }
  }), _vm._v(" "), _c('div', [_vm._v("秒")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [(_vm.getTimeSecond(_vm.formData.time) > 0) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "large",
      "disabled": "disabled"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("已提交\n                ")]) : _c('van-button', {
    attrs: {
      "type": "info",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-foot"
  }, [(_vm.type == 'auto') ? _c('van-button', {
    on: {
      "click": _vm.onTypeChange
    }
  }, [_vm._v("手动计时")]) : _c('van-button', {
    on: {
      "click": _vm.onTypeChange
    }
  }, [_vm._v("自动计时")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c9e810","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/TimeScore.vue
// module id = 2351
// module chunks = 0